module.exports = __webpack_public_path__ + "static/media/chargext-4.9d09c407.jpg";